import { TinyAvatar } from "MVVM/Views/MatchHistory/styledComponents";
import { Flex, Text } from "rebass/styled-components";
import styled from "styled-components";
import { StyledMomentIcon } from "../Match/styledComponents";
import { TMoment } from "MVVM/Views/MatchHistory/@types";
import { ESupportedGames } from "MVVM/@types";

export const MomentDetails = ({
  moment,
  hideTimelineLabel,
  matchHistoryGame,
}: {
  moment: TMoment;
  hideTimelineLabel?: boolean;
  matchHistoryGame?: ESupportedGames;
}) => {
  return (
    <DetailsContainer>
      {!hideTimelineLabel && (
        <Text variant="text.labelXSmall">{moment.timelineLabel}</Text>
      )}
      <Players>
        <TinyAvatar src={moment.player.avatar} />
        <StyledMomentIcon
          src={moment.icons[0]}
          className="hide-on-mobile"
          shouldFlipImage={matchHistoryGame === ESupportedGames.VALORANT}
        />
        {moment.victimData.map((victim, index) => (
          <TinyAvatar
            key={`victim-${victim.gameId}-${index}`}
            src={victim.avatar}
            className="hide-on-mobile"
          />
        ))}
      </Players>
      <MomentTitle>
        <Text
          variant="text.labelSmall"
          style={{
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
          }}
        >
          {moment.title}
        </Text>
      </MomentTitle>
    </DetailsContainer>
  );
};
const DetailsContainer = styled(Flex)`
  align-items: center;
  background: ${(props) => props.theme.colors.midnightAlpha70};
  border-radius: 8px;
  border: 1px solid ${({ theme }) => theme.colors.chalkAlpha20};
  flex-wrap: wrap-reverse;
  gap: 24px;
  height: auto;
  justify-content: center;
  left: 22px;
  padding: 8px 12px 8px 16px;
  position: absolute;
  top: 110px;
  width: 90%;
`;

const Players = styled(Flex)`
  align-items: center;
  gap: 8px;

  @media (max-width: ${({ theme }) => theme.breaks.small}) {
    .hide-on-mobile {
      display: none;
    }
  }
`;

const MomentTitle = styled(Flex)`
  align-items: center;
`;
